<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  mounted() {
    // Initialize store state from localStorage on app start
    this.$store.commit("INIT_STATE");
  }
};
</script>